import clsx from 'clsx'
import {createContext, useContext, useState} from 'react'
import {useLayout} from '../../core'
import {SidebarLogo} from './SidebarLogo'
import {SidebarMenu} from './sidebar-menu/SidebarMenu'

type SidebarContextType = {
  collapsed: boolean
  toggle: () => void
  expand: () => void
}

export const SidebarContext = createContext<SidebarContextType>({
  collapsed: false,
  toggle: () => {},
  expand: () => {},
})

export const useSidebar = () => useContext(SidebarContext)

const Sidebar = () => {
  const {config} = useLayout()
  const [collapsed, setCollapsed] = useState(false)

  if (!config.app?.sidebar?.display) {
    return null
  }

  return (
    <SidebarContext.Provider
      value={{
        collapsed,
        toggle: () => setCollapsed((c) => !c),
        expand: () => setCollapsed(false),
      }}
    >
      <div
        id='kt_app_sidebar'
        className={clsx(
          'sticky top-0 z-[100] flex shrink-0 flex-col items-stretch overflow-hidden bg-[#131313] py-5 transition-all duration-300 min-h-screen',
          collapsed ? 'w-[75px] px-1' : 'w-[200px] px-2'
        )}
      >
        <SidebarLogo />
        <SidebarMenu />
      </div>
    </SidebarContext.Provider>
  )
}

export {Sidebar}
